import { render, staticRenderFns } from "./AccountAppeal.vue?vue&type=template&id=71defdc2&scoped=true&"
import script from "./AccountAppeal.vue?vue&type=script&lang=js&"
export * from "./AccountAppeal.vue?vue&type=script&lang=js&"
import style0 from "./AccountAppeal.vue?vue&type=style&index=0&id=71defdc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71defdc2",
  null
  
)

export default component.exports